export enum ERoutes {
  ABOUT = 'o-aplikaciji',
  APPS = 'apps',
  APPS_IOS = 'ios',
  APPS_ANDROID = 'android',
  APPS_WINDOWS = 'windows',
  APPS_MACOS = 'macos',
  APPS_LINUX = 'linux',
  APPS_WEB = 'web',
  APPS_CLI = 'cli',
  ARTICLES = 'articles',
  COOKIE_POLICY = 'politika-kolacica',
  DATA = 'data',
  HELP = 'pomoc',
  MAP = 'mapa',
  METHODOLOGY = 'metodologija',
  MUNICIPALITY = 'statistika/:name',
  OPEN_DATA = 'otvoreni-podaci',
  PRIVACY_POLICY = 'politika-privatnosti',
  SOLUTIONS = 'solutions',
  SOLUTIONS_OVERVIEW = 'overview',
  SOLUTIONS_CROWD = 'crowdsourcing-applications',
  SOLUTIONS_WEB = 'web-portal',
  SOLUTIONS_REGULATORY = 'regulatory-portal',
  SOLUTIONS_DASHBOARDS = 'dashboards',
  SOLUTIONS_AUTO = 'automated-measurements',
  STATISTICS = 'statistika',
  TERMS_OF_SERVICE = 'uslovi-koriscenja',
  TEST = 'test',
  TEST_PROGRESS = 'progress',
  TEST_HISTORY = 'istorija',
  TEST_HYSTORY_RESULTS = 'rezultate/:id',
  PAGE_NOT_FOUND = 'stranica-nije-pronadena',
  WIZARD = 'wizard',
  CONTACT = 'contact',
}
